@if (mobile) {
@if (isAuthorize) {
<lgfg-header-mobile [profileSettingsModal]="profileSettingsModal"></lgfg-header-mobile>
<notification [isMobile]="true"></notification>
}
<main>
    <router-outlet></router-outlet>
</main>
} @else {
<div class="site-wrap">
    <div class="site-wrap__container">
        <div class="site-wrap__sidebar">
            @if (isAuthorize) {
            <sidebar-desktop (openSideBar)="onOpenSideBar($event)"></sidebar-desktop>
            }
        </div>
        <div style="width: 100%;">
            @if (isAuthorize) {
            <div class="site-wrap__header">
                <lgfg-header-desktop [profileSettingsModal]="profileSettingsModal"></lgfg-header-desktop>
            </div>
            }
            <div [ngStyle]="{'width': bodyMaxWidth + 'px'}" style="overflow-x: hidden;">
                <main>
                    <router-outlet></router-outlet>
                    <ngx-spinner style="height: 400px;" name="Processing" [fullScreen]="true" [template]="loaderImg"
                        color="red" size="large" [zIndex]="1000" bdColor="rgba(1,1,1,0.8)">
                        <p class="loading">Processing. Please wait…</p>
                    </ngx-spinner>
                </main>
            </div>
        </div>
    </div>
</div>
}
<profile-settings-modal #profileSettingsModal></profile-settings-modal>